"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var SettingsChildrenStats_1 = require("../../model/dto/SettingsChildrenStats");

var SettingsChildrenStatsConverter_1 = require("./SettingsChildrenStatsConverter");
/**
 * Default implementation of {@link SettingsChildrenStatsConverter}. It is meant for JSON conversions only.
 *
 * @author Radek Beran
 */


var SettingsChildrenStatsConverterImpl =
/*#__PURE__*/
function (_SettingsChildrenStat) {
  _inherits(SettingsChildrenStatsConverterImpl, _SettingsChildrenStat);

  function SettingsChildrenStatsConverterImpl() {
    _classCallCheck(this, SettingsChildrenStatsConverterImpl);

    return _possibleConstructorReturn(this, _getPrototypeOf(SettingsChildrenStatsConverterImpl).call(this));
  }
  /**
   * @inheritDoc
   */


  _createClass(SettingsChildrenStatsConverterImpl, [{
    key: "toObject",
    value: function toObject(source, conversions) {
      return new SettingsChildrenStats_1.SettingsChildrenStats(source.includedChildrenCount, source.childrenCount);
    }
    /**
     * Converts domain model object to an external representation of the object. This conversion is meant for JSON conversions only.
     *
     * @param source {@link SettingsChildrenStats}
     * @param conversions implementation of DataObjectConversions according data representation
     * @returns document JSON representing the domain model object
     */

  }, {
    key: "toDocument",
    value: function toDocument(source, conversions) {
      return {
        includedChildrenCount: source.includedChildrenCount,
        childrenCount: source.childrenCount
      };
    }
  }]);

  return SettingsChildrenStatsConverterImpl;
}(SettingsChildrenStatsConverter_1.SettingsChildrenStatsConverter);

exports.SettingsChildrenStatsConverterImpl = SettingsChildrenStatsConverterImpl;